var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useRecoilState } from 'recoil';
import { confirmHookState } from '@/presentation/components';
function useConfirm(props = {}) {
    const [state, setState] = useRecoilState(confirmHookState);
    const handleClose = useCallback(() => {
        setState(prev => (Object.assign(Object.assign({}, prev), { show: false, confirmed: false })));
    }, [setState]);
    const handleConfirm = useCallback(() => {
        setState(prev => (Object.assign(Object.assign({}, prev), { show: false, confirmed: true })));
    }, [setState]);
    const onConfirmMessage = useCallback((newData) => __awaiter(this, void 0, void 0, function* () {
        setState(prev => {
            var _a, _b, _c;
            return (Object.assign(Object.assign({}, prev), { show: true, confirmed: null, title: (_a = newData === null || newData === void 0 ? void 0 : newData.title) !== null && _a !== void 0 ? _a : prev.title, message: (_b = newData === null || newData === void 0 ? void 0 : newData.message) !== null && _b !== void 0 ? _b : prev.message, textConfirm: (_c = newData === null || newData === void 0 ? void 0 : newData.textConfirm) !== null && _c !== void 0 ? _c : prev.textConfirm }));
        });
        return new Promise(resolve => {
            const interval = setInterval(() => {
                setState(prev => {
                    if (prev.confirmed !== null) {
                        clearInterval(interval);
                        resolve(prev.confirmed);
                        return Object.assign(Object.assign({}, prev), { confirmed: null }); // Reset the confirmed state for future invocations
                    }
                    return prev;
                });
            }, 100);
        });
    }), [setState]);
    const confirmContainer = (React.createElement(Modal, { show: state.show, onHide: handleClose },
        React.createElement(Modal.Header, { closeButton: true },
            React.createElement(Modal.Title, null, state.title)),
        React.createElement(Modal.Body, null, state.message),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { variant: "secondary", onClick: handleClose }, "Cancel"),
            React.createElement(Button, { variant: "primary", onClick: handleConfirm }, state.textConfirm))));
    return { confirmContainer, onConfirmMessage };
}
export default useConfirm;
